import React from 'react';

const Healthcheck = () => {
  return (
    <div data-testid="healthcheck">
      <div>OK - Service is healthy</div>
    </div>
  );
};

export default Healthcheck;